import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { useMerchants } from '../../store/merchnts/merchants-context';

import './RelatedEntityNameLink.scss';

export enum RELATED_ENTITY_TYPE {
    MASTER = 'MasterAccount',
    PARTNER = 'Partner',
    MERCHANT = 'Merchant',
}

interface Props {
    name?: string;
    id: string;
    type: RELATED_ENTITY_TYPE | string;
    redirectUrl?: string;
}

export const RelatedEntityNameLink = (props: Props): React.ReactElement => {
    const { name, id, type, redirectUrl } = props;
    const { merchantState: { merchantNames, partnerNames }} = useMerchants();

    const getLinkUrl = (): string => {
        switch (type) {
            case RELATED_ENTITY_TYPE.MERCHANT: return redirectUrl || `/accounts/merchants/${id}/business-information`;
            case RELATED_ENTITY_TYPE.PARTNER: return redirectUrl || `/partners/${id}/partner-info`;
        }
    };

    const getRelatedEntityName = (): string => {
        let clientName = '';
        if (name) {
            clientName = name;
        } else if (id && type === RELATED_ENTITY_TYPE.MERCHANT) {
            clientName = merchantNames?.[id] ?? id;
        } else if (id && type === RELATED_ENTITY_TYPE.PARTNER) {
            clientName = partnerNames?.[id] ?? id;
        } else if (type === RELATED_ENTITY_TYPE.MASTER) {
            clientName = RELATED_ENTITY_TYPE.MASTER;
        } else {
            clientName = '-';
        }
        return clientName;
    };

    const getRelatedEntityLink = (): JSX.Element => {
        if (!name && !id) {
            return <div className="fw-bolder fc-text-overflow">{getRelatedEntityName()}</div>;
        }
        switch (type) {
            case RELATED_ENTITY_TYPE.MASTER:
                return (
              <div className="fw-bolder fc-text-overflow">{getRelatedEntityName()}</div>
            );
            case RELATED_ENTITY_TYPE.MERCHANT:
            case RELATED_ENTITY_TYPE.PARTNER: return (
                <Link
                    to={getLinkUrl()}
                    target="_blank"
                    className="fw-bolder cursor-pointer main-font-family text-danger fc-merchant-name-link fc-text-overflow"
                >
                    {getRelatedEntityName()}
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ms-2 w-10px"/>
                </Link>
            );
            default: return <div className="fw-bolder fc-text-overflow">{getRelatedEntityName()}</div>;
        }
    };

    return (
      <>
          {getRelatedEntityLink()}
      </>
    );
};
